/**
 * Zentrale Datums-Utilities für konsistente Zeitzone-Behandlung
 */

// Zentrale Zeitzone-Konfiguration
export const APP_TIMEZONE = 'Europe/Berlin';

/**
 * Konvertiert ein Datum in die App-Zeitzone (Europe/Berlin)
 */
export function toAppTimezone(date: Date): Date {
  return new Date(date.toLocaleString("en-US", {
    timeZone: APP_TIMEZONE
  }));
}

/**
 * Erstellt ein normalisiertes Datum (00:00:00) in der App-Zeitzone
 */
export function normalizeDate(date: Date | string): Date {
  const inputDate = typeof date === 'string' ? new Date(date) : date;
  
  // Konvertiere in App-Zeitzone und setze Zeit auf 00:00:00
  const appTimezonDate = toAppTimezone(inputDate);
  appTimezonDate.setHours(0, 0, 0, 0);
  
  return appTimezonDate;
}

/**
 * Vergleicht zwei Daten (nur das Datum, nicht die Zeit)
 */
export function isSameDate(date1: Date, date2: Date): boolean {
  const norm1 = normalizeDate(date1);
  const norm2 = normalizeDate(date2);
  return norm1.getTime() === norm2.getTime();
}

/**
 * Formatiert ein Datum für die deutsche Anzeige
 */
export function formatDateDE(date: Date): string {
  return toAppTimezone(date).toLocaleDateString('de-DE', {
    timeZone: APP_TIMEZONE
  });
}

/**
 * Formatiert einen Datums-String für die deutsche Anzeige
 */
export function formatDateRangeDE(startDate: Date, endDate: Date): string {
  return `${formatDateDE(startDate)} - ${formatDateDE(endDate)}`;
}

/**
 * Erstellt ein Date-Objekt aus Jahr, Monat, Tag in der App-Zeitzone
 */
export function createDateInAppTimezone(year: number, month: number, day: number): Date {
  // Monat ist 0-basiert in JavaScript
  return new Date(Date.UTC(year, month, day));
}

/**
 * Prüft ob ein Datum zwischen zwei anderen Daten liegt
 */
export function isDateBetween(date: Date, startDate: Date, endDate: Date): boolean {
  const normalizedDate = normalizeDate(date);
  const normalizedStart = normalizeDate(startDate);
  const normalizedEnd = normalizeDate(endDate);
  
  return normalizedDate >= normalizedStart && normalizedDate <= normalizedEnd;
}